import { modals } from '@mantine/modals';

import { IconCheck } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../shared/components/UI/Button/Button';
import { Loader } from '../../shared/components/UI/Loader/Loader';

import { EditStreamLayout } from '../../features/streams/components/EditStreamLayout';
import { AdvancedFields } from '../../features/streams/components/forms/components/AdvancedFields';
import { BasicFields } from '../../features/streams/components/forms/components/BasicFields';
import { useStreamsQuery } from '../../features/streams/components/forms/hooks/streams.hook';
import { useStreamForm } from '../../features/streams/components/forms/hooks/useStreamForm';

export default function CreateStreamPage() {
  const { t } = useTranslation('stream');
  const navigate = useNavigate();

  const {
    form,
    isFormValid,
    isFormDirty,
    searchTendersPreviewQuery,
    queryKeys,
    createStream,
  } = useStreamForm();

  const streamsQuery = useStreamsQuery();

  if (streamsQuery.isLoading) {
    return <Loader title="Chargement..." />;
  }

  const handleBackNav = () => {
    if (isFormDirty) {
      modals.openContextModal({
        modal: 'streamDiscard',
        size: 'lg',
        innerProps: {
          isFormValid,
          onDiscard: () => navigate(-1),
          onSubmit: () => {
            createStream();
            navigate(-1);
          },
        },
      });
    } else {
      navigate(-1);
    }
  };

  const footerCTA = (
    <Button leftIcon={<IconCheck />} onClick={createStream}>
      {t('createStream.createMyStream')}
    </Button>
  );

  return (
    <EditStreamLayout
      handleBackNav={handleBackNav}
      footerCTA={footerCTA}
      previewQuery={searchTendersPreviewQuery}
      queryKeys={queryKeys}
    >
      <BasicFields form={form} />
      <AdvancedFields form={form} />
    </EditStreamLayout>
  );
}
